<template>
    <div>
        <div v-for="item in monthList" :key="item">
            <hua-index-anchor :index="item + '月'" />
            <template v-for="(items, index) in myData">
                <record-cell
                    v-if="item === items.v_time.split('-')[1]"
                    :key="items.id + index"
                    :item="items"
                    :index="index"
                    :active="active"
                ></record-cell>
            </template>
        </div>
    </div>
</template>

<script>
import recordCell from '@/view/myVisitorList/components/recordCell.vue'
import utils from '@/constants/utils'
import image from '@/image/head.jpg'
export default {
    components: {
        recordCell,
    },
    props: {
        myData: {
            type: Array,
        },
    },
    mounted() {
        this.myData.map((item) => {
            if (item.v_capturePic) {
                item.v_capturePic = this.getImageUrl(item.v_capturePic, item.id)
            }
            item.statusName =
                item.status === 0
                    ? '待审核'
                    : item.status === 2
                    ? '在访'
                    : item.status === 3
                    ? '离访'
                    : item.status

            this.monthList.push(item.v_time.split('-')[1])
        })
        this.monthList = [...new Set(this.monthList)]
    },
    data() {
        return {
            active: 'mylist',
            monthList: [],
            dataList: [],
            defaultImage: image,
        }
    },
    methods: {
        getImageUrl(url, id) {
            console.log('myBookingList-------------getImageUrl',url, id);
            return utils.getImgUrl(url, id) || this.defaultImage
        },
    },
}
</script>

<style>
</style>